import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["tags", "triggerAnalytics", "menuItems"];
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import { Link } from "@argo/ui-elements";
import { colors, size, typography, breakpoints } from "@argo/principles";
import { rgba } from "@argo/utils";
import { navbp } from '../utils/constants';
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
var primary = colors.primary,
  blue = colors.blue;
var Menu = styled('ul')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  list-style: none;\n  margin: 0 0 ", "px ", "px;\n  border-left: 1px solid ", ";\n  padding: 0;\n\n  li {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  a {\n    display: block;\n    padding: ", "px ", "px;\n    line-height: ", "px;\n  }\n\n  @media (min-width: ", "px) {\n    margin-left: ", "px;\n\n    a {\n      padding: ", "px ", "px;\n    }\n  }\n\n  @media (min-width: ", ") {\n    columns: ", ";\n    column-gap: 0;\n    column-rule: 1px solid ", ";\n    white-space: nowrap;\n    list-style: none;\n    margin: 0;\n    border: 0;\n    padding: ", "px 0;\n\n    li {\n      break-inside: avoid;\n    }\n\n    a {\n      padding: ", "px 36px;\n      line-height: ", "px;\n    }\n  }\n"])), typography.types.body, blue.mutedBlue, primary.white, size.md, size.sm, rgba(primary.white, .25), size.xs, size.sm, size.sm, breakpoints.lg, size.md, size.xs, size.md, navbp.extraWideViewport, function (props) {
  return Math.ceil(props.children.length / 6);
}, rgba(colors.primary.white, .25), size.sm, size.xs, size.lg);
export default (function (_ref) {
  var tags = _ref.tags,
    triggerAnalytics = _ref.triggerAnalytics,
    menuItems = _ref.menuItems,
    rest = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(Menu, rest, menuItems.map(function (menuLink, i) {
    return React.createElement("li", {
      key: i
    }, React.createElement(Link, {
      onClick: triggerAnalytics && triggerAnalytics({
        googleTag: menuLink.googleTag,
        pixallTag: menuLink.pixallTag
      }),
      "data-automation": menuLink.omnitureTag,
      "data-partner": menuLink.partnerLink,
      "data-tag-id": "NavDropdown".concat(i),
      type: 'unstyled',
      href: "".concat(GLOBALNAV_KBB_BASE_URL).concat(menuLink.url)
    }, menuLink.name));
  }));
});